module.exports = __webpack_public_path__ + "img/notfound.48782a2c.png";